const mediaDeclaration = '@media';

const breakPoint = {
  sp: 768,
  tb: 1400,
};

export const mediaQuery = {
  sp: `${mediaDeclaration} (max-width: ${breakPoint.sp - 1}px)`,
  tb: `${mediaDeclaration} (max-width: ${breakPoint.tb - 1}px)`,
};
